var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 34,
    viewBox: "0 0 48 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 5.08333C32.2115 5.08333 39.5348 9.69833 43.1098 17C39.5348 24.3017 32.2332 28.9167 23.9998 28.9167C15.7665 28.9167 8.46484 24.3017 4.88984 17C8.46484 9.69833 15.7882 5.08333 23.9998 5.08333ZM23.9998 0.75C13.1665 0.75 3.91484 7.48833 0.166504 17C3.91484 26.5117 13.1665 33.25 23.9998 33.25C34.8332 33.25 44.0848 26.5117 47.8332 17C44.0848 7.48833 34.8332 0.75 23.9998 0.75ZM23.9998 11.5833C26.9898 11.5833 29.4165 14.01 29.4165 17C29.4165 19.99 26.9898 22.4167 23.9998 22.4167C21.0098 22.4167 18.5832 19.99 18.5832 17C18.5832 14.01 21.0098 11.5833 23.9998 11.5833ZM23.9998 7.25C18.6265 7.25 14.2498 11.6267 14.2498 17C14.2498 22.3733 18.6265 26.75 23.9998 26.75C29.3732 26.75 33.7498 22.3733 33.7498 17C33.7498 11.6267 29.3732 7.25 23.9998 7.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon_eye.bbad5c94dd4660fe10cbbe55e32ea090.svg";
export { ForwardRef as ReactComponent };